module.exports = __webpack_public_path__ + "static/img/3234_phase_function_Paper_PointsHejduk_Prediction.957cef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3234_phase_function_Paper_PointsHejduk_Prediction.png
// module id = u0sG
// module chunks = 0